import React from 'react'
import styles from './Footer.module.scss'
import { useTranslation } from 'react-i18next'
import { DropDown } from '@digicert/dcone-common-ui'
import { ReactComponent as GlobeAmericas } from '../../assets/images/globe-americas.svg'
import { FooterProps } from './Footer.types'

const Footer = (
  {
    locales,
    currentLanguage,
    customSettings
  }: FooterProps) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear()

  return (
    <div className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.languageOptions}>
          <GlobeAmericas className={styles.icon}/>
          <DropDown label={currentLanguage} items={locales} color='white' placement='topRight'/>
        </div>

        <nav className={styles.nav}>
            {customSettings?.urls.termsOfUse && <a className={styles.link} href={customSettings?.urls.termsOfUse}>{t('footer.agreement.terms')}</a>}
            {customSettings?.urls.privacyPolicy && <a className={styles.link} href={customSettings?.urls.privacyPolicy}>{t('footer.agreement.policy')}</a>}
            {customSettings?.urls.legalRepository && <a className={styles.link} href={customSettings?.urls.legalRepository}>{t('footer.agreement.legal')}</a>}
            {customSettings?.urls.webtrustAudit && <a className={styles.link} href={customSettings?.urls.webtrustAudit}>{t('footer.agreement.audit')}</a>}
            {customSettings?.urls.support && <a className={styles.link} href={customSettings?.urls.support}>{t('footer.agreement.support')}</a>}
            {customSettings?.urls.contactUs && <a className={styles.link} href={customSettings?.urls.contactUs}>{t('footer.agreement.contact')}</a>}
        </nav>

        <div className={styles.copyRights}>
          &copy; {currentYear} {customSettings?.copyright === "" ? t('footer.agreement.copyright') : customSettings?.copyright}
        </div>
      </div>
    </div>
  )
}

export default Footer